import { Button } from "components/Button/Button"
import { useLangContext } from "context/Lang"
import { BoxesIcon, ExternalLink } from "lucide-react"
import { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import {  useNavigate } from "react-router-dom"
import { routes } from "routes"
import { Editor } from "views/editor/editor"


type PreviewBuildingProps = {
    data: EditorItemType
}

export const PreviewBuilding = ({ data }: PreviewBuildingProps) => {


    const navigate = useNavigate();
    const { gW } = useLangContext();

    const [block, setBlock] = useState<boolean>(true);
 


    useEffect(() => {

    }, []);



    return <div className="  w-full overflow-hidden h-[400px]  rounded-xl  relative shadow-inner ">

        <Editor canEdit={false} inDialog={true} editorId={data?.id} onDataLoad={() => {
            setBlock(false)
        }} />

        {block && <div className="absolute inset-0 bg-primary-900   flex items-center justify-center">
            <div className="text-center text-white/50 space-y-2">
                <BoxesIcon size={40} className="mx-auto animate-pulse" />
                <p className="text-xs uppercase tracking-widest">{gW("loading-3d")}</p>
            </div>
        </div>}




        {/* <Editor /> */}

        {/* زر سريع للانتقال للمحرر الكامل من داخل المعاينة */}
        <div className="absolute bottom-4 right-4">
            <Button
                size="sm"
                className="rounded-full     shadow-lg"
                onClick={() => navigate(routes.editor + `?editorId=${data?.id}`)}
            >
                <ExternalLink size={14} className="me-2" />
                {gW("full-editor")}
            </Button>
        </div>
    </div>
}